export default class ImageKeys {
  static BAR = 'bar';
}
